function getServer() {
  // return 'https://api.liberrex.tn/v1';
  // return 'http://localhost:8003/v1';
  var country = null;

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  if (urlParams.get("country")) {
    country = urlParams.get("country");
    localStorage.setItem("server", urlParams.get("country"));
  } else {
    country = localStorage.getItem("server");
  }

  if (
    process.env.VUE_APP_EDIT_HOST === "true" &&
    localStorage.getItem("host") != null
  ) {
    return localStorage.getItem("host");
  } else {
    switch (country) {
      case "tn":
        return process.env.VUE_APP_API_URL_TN;
      case "ci":
        return process.env.VUE_APP_API_URL_CI;
      case "gb":
        return process.env.VUE_APP_API_URL;
      default:
        return process.env.VUE_APP_API_URL_TN;
    }
  }
}

export const ApiConfigs = {
  base_url: getServer() + "/business",
  broadcast_url: getServer() + "/broadcasting",
  base_display_url: getServer() + "/display",
  /* -------------------------------- */
  // PUSHER
  pusher: {
    auth: "/auth",
  },

  //DISPLAY LOGIN
  display: {
    login: "/auth",
    logout: "/logout",
    refresh: "/refresh",
    autoLogin: "/auth/:key/:token",
    ping: "/ping",
    generateAuthCode: "/auth/generate",
    ConfirmAuthByCode: "/auth/confirm"
  },
  // QUEUES
  queues: {
    // QUEUE RELATED
    get: "/queue/:id",
    getInService: "/queue/:id/inservice",
    getWaitingList: "/queue/:id/waitinglist",

    getInServiceTickets: "/queues/inServiceTickets",

    voiceTelling: "/voice",
  },
};
